import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";

const User: IModel = {
  title: "ZP",
  apiPath: "zp",
  forms : {
    "default": {
      fields: ["kategorija_zastite", "naziv_akt"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "naziv_akt", "kategorija_zastite"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Naziv",
      source: "naziv_akt",
      ttoken: "data.naziv",
      type: "text",
      validation: {
        maxLength: 100
      }
    },
    {
      title: "Vrsta",
      source: "kategorija_zastite",
      ttoken: "data.vrsta",
      type: "text",
      validation: {
        maxLength: 100
      }
    }
  ]
}

export default User;
